import { render, staticRenderFns } from "./RoutingStatus.vue?vue&type=template&id=2440e574&scoped=true&"
import script from "./RoutingStatus.vue?vue&type=script&lang=js&"
export * from "./RoutingStatus.vue?vue&type=script&lang=js&"
import style0 from "./RoutingStatus.vue?vue&type=style&index=0&id=2440e574&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2440e574",
  null
  
)

export default component.exports